import React, { ReactElement } from "react";

import { graphql, useStaticQuery } from "gatsby";

import iconHelper from "../../utils/iconHelper";
import SubNavPoint from "../subNavPoint/subNavPoint";

interface SspNavigationProps {
  className?: string;
}

const SspNavigation: React.FC<SspNavigationProps> = ({ className = undefined }) => {
  const data: { sspNavigation: Queries.kontent_item_navigation_item } = useStaticQuery(graphql`
    {
      sspNavigation: kontentItemNavigationItem(system: { codename: { eq: "ssp_navigation" } } ) {
        id
        elements {
          elements {
            value {
              id
              typename: __typename
              preferred_language
              ... on kontent_item_navigation_item {
                id
                elements {
                  title {
                    value
                  }
                  external_url {
                    value
                  }
                  icon {
                    value {
                      codename
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const sspNavigation: ReactElement[] = [];

  if (data.sspNavigation) {
    data.sspNavigation?.elements?.elements?.value?.forEach((item) => {
      const navItem = item as Queries.kontent_item_navigation_item;

      sspNavigation.push(
        <SubNavPoint
          title={navItem.elements?.title?.value}
          href={navItem.elements?.external_url?.value || navItem.id}
          className={className}
          key={navItem.elements?.title?.value}
        >
          {iconHelper(navItem.elements?.icon?.value?.[0]?.codename)}
          {navItem.elements?.title?.value}
        </SubNavPoint>,
      );
    });
  }

  return sspNavigation;
};

export default SspNavigation;
